import { useEffect } from 'react';

const SITE_NAME = 'SoundWolves';
const DEFAULT_DESCRIPTION =
  'SoundWolves — The Cultural Nightlife Operating System. Discover exclusive nightlife events, book legendary DJs, and unlock VIP experiences across North America.';
const DEFAULT_IMAGE = 'https://soundwolves.com/logo.png';

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

/**
 * Per-route document metadata for this SPA. Sets a unique <title> plus the
 * description and Open Graph / Twitter tags so each route is distinct and
 * shared links render a sensible preview.
 *
 * @param {string} title    Page-specific title (without the site suffix).
 * @param {string} [description]
 * @param {object} [opts]   { image, suffix } — suffix defaults to "| SoundWolves".
 */
export function usePageMeta(title, description = DEFAULT_DESCRIPTION, opts = {}) {
  const image = opts.image || DEFAULT_IMAGE;
  // The home page passes its own full title; others get the brand suffix.
  const fullTitle =
    opts.suffix === false || !title
      ? title || SITE_NAME
      : `${title} | ${SITE_NAME}`;

  useEffect(() => {
    document.title = fullTitle;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', image);
    setMeta('property', 'og:url', window.location.href);
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', image);
  }, [fullTitle, description, image]);
}

export default usePageMeta;
